import styled from "styled-components";

export const GridWrapper = styled.div`
	margin: 0 auto;
	max-width: ${({theme}) => theme.grid.outer};
`;
